import React, { useContext } from "react";

// react router dom
import { Link, useNavigate } from "react-router-dom";

// context
import { AuthContext } from "../../context/AuthContext";
import { SideDrawerContext } from "../../context/SideDrawerContext";

const Logo = () => {
  const {
    state: { homePath },
  } = useContext(AuthContext);

  const siderContext = useContext(SideDrawerContext);

  const navigate = useNavigate();

  // logo click function
  const logoClickedHandler = () => {
    navigate(homePath);
  };

  return (
    <div className="logo" onClick={logoClickedHandler}>
      <Link to={homePath} className="logo-link">
        <img src="https://i.imgur.com/Cx6rjiB.png" alt="mtor logo" />

        {!siderContext.collapsed && (
          <div className="logo-name">
            <span>mtor</span>
            <span>موتور</span>
          </div>
        )}
      </Link>
    </div>
  );
};

export default Logo;
